import service from '@/utils/server';

const modName='/freeGoods/order/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'toBeConfirmedPageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};
//查询详情
export const detail = data => {
  return service({
    url: '/freeGoods/toOrder/detail/' + data,
    method: 'post',
    data
  });
};

//删除方法
export const orderConfirmSubmit = data => {
  return service({
    url: modName + 'orderConfirmSubmit',
    method: 'post',
    data
  });
};

//删除方法
export const orderConfirmReject = data => {
  return service({
    url: modName + 'orderConfirmReject',
    method: 'post',
    data
  });
};

export const setOriginalOrderNo = data => {
  return service({
    url: modName+'setOriginalOrderNo',
    method: 'post',
    data
  })
};

//模板下载
export const downtemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};

//修改订单明细数量导入
export const updateOrderDtQtyUpload = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'updateOrderDtQtyUpload',
    method: 'post',
    data
  });
};

//修改订单明细数量-确认修改
export const updateOrderDtQtyConfirm = data => {
  return service({
    url: modName + 'updateOrderDtQtyConfirm',
    method: 'post',
    data
  });
};

//新旧品替换导入
export const updateOrderDtProductUpload = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'updateOrderDtProductUpload',
    method: 'post',
    data
  });
};

//新旧品替换-确认修改
export const updateOrderDtProductConfirm = data => {
  return service({
    url: modName + 'updateOrderDtProductConfirm',
    method: 'post',
    data
  });
};


//初始化页面对象
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'toBeConfirmedExport',
    method: 'post',
    data
  });
};
//查询订单详情
export const conOrderDetail = data => {
  return service({
    url: '/freeGoods/order/orderDetail/' + data,
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/order/confirm/api/index.js